<template>
  <div class="desk-page">
    <h1>嗨喵工作台下载</h1>

    <!-- 顶栏 -->
    <div class="desk-nav">
      <div class="dn-inner">
        <img
          class="dn-logo"
          src="https://ustatic.hudongmiao.com/miao/common/desk-logo_1791775464711f52204.webp"
          alt="嗨喵悦动,嗨喵互动,嗨喵工作台logo"
        />
        <div class="dn-title">
          <span class="dn-name">嗨喵工作台</span>
          <span class="dn-slogan">现场大屏互动，打开就能用</span>
        </div>
        <a class="dn-home" href="https://www.hudongmiao.com" target="_blank" rel="noopener">嗨喵首页</a>
        <div class="dn-cta" @click="onNavCta">
          <svg viewBox="0 0 24 24" class="dn-cta-icon">
            <path
              d="M12 3v11m0 0l-4.2-4.2M12 14l4.2-4.2M5 19.4h14"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span>立即下载</span>
        </div>
      </div>
    </div>

    <!-- 首屏 -->
    <div class="desk-hero">
      <div class="hero-card">
        <div class="hero-left">
          <span class="hero-eyebrow">嗨喵 · 大屏互动桌面端</span>
          <h2 class="hero-title">
            今天的现场
            <br />
            <em>从这里开始</em>
          </h2>
          <p class="hero-sub">登录嗨喵账号，在线互动、现场播控双模式，一键把互动大屏投上现场大屏幕。</p>
          <ul class="hero-list">
            <li v-for="(item, i) in highlights" :key="i">
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" fill="rgba(255, 255, 255, 0.16)" />
                <path
                  d="M7.6 12.4l3 3 5.8-6"
                  fill="none"
                  stroke="#fff"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>{{ item }}</span>
            </li>
          </ul>

          <div class="download-card">
            <div class="dl-primary" @click="downloadPrimary">
              <svg v-if="!isMac" viewBox="0 0 24 24" class="dl-os-icon">
                <path
                  d="M3 5.6l7.6-1.1v6.9H3V5.6zM3 12.6h7.6v6.9L3 18.4v-5.8zM11.8 4.3L21 3v8.4h-9.2V4.3zM11.8 12.6H21V21l-9.2-1.3v-7.1z"
                />
              </svg>
              <svg v-else viewBox="0 0 20 24" class="dl-os-icon apple">
                <path
                  d="M16.365 12.44c-.02-2.19 1.79-3.24 1.87-3.29-1.02-1.49-2.61-1.7-3.17-1.72-1.35-.14-2.63.79-3.31.79-.68 0-1.74-.77-2.86-.75-1.47.02-2.83.86-3.58 2.17-1.53 2.66-.39 6.6 1.1 8.76.73 1.06 1.6 2.25 2.74 2.21 1.1-.04 1.51-.71 2.84-.71 1.33 0 1.7.71 2.86.69 1.18-.02 1.93-1.08 2.65-2.15.84-1.22 1.18-2.41 1.2-2.47-.03-.01-2.31-.89-2.34-3.53zM14.2 5.9c.6-.73 1.01-1.75.9-2.76-.87.04-1.92.58-2.54 1.31-.56.65-1.05 1.68-.92 2.67.97.08 1.96-.49 2.56-1.22z"
                />
              </svg>
              <span class="dl-text">{{ primaryLabel }}</span>
              <svg viewBox="0 0 24 24" class="dl-go">
                <path
                  d="M12 4v12m0 0l-5-5m5 5l5-5M6 20h12"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="dl-others">
              <span class="dl-others-label">其他系统</span>
              <a
                v-for="p in otherPlatforms"
                :key="p.key"
                :href="p.url"
                target="_blank"
                rel="noopener"
                >{{ p.name }}</a
              >
            </div>
            <div class="dl-meta">
              <span v-if="primaryVersion" class="dl-version">最新版本 v{{ primaryVersion }}</span>
              <span class="dl-tip">官方 CDN 直链，下载后双击安装</span>
            </div>
          </div>
        </div>

        <div class="hero-right">
          <i class="ring ring-1" aria-hidden="true"></i>
          <i class="ring ring-2" aria-hidden="true"></i>
          <div class="hero-window">
            <img :src="shotHome" alt="嗨喵悦动,嗨喵互动,嗨喵工作台首页" />
            <span class="hero-badge">全新双模式工作台</span>
          </div>
          <img
            class="hero-appicon"
            src="https://ustatic.hudongmiao.com/miao/common/desk-logo_1791775464711f52204.webp"
            alt="嗨喵悦动,嗨喵互动,嗨喵工作台图标"
          />
        </div>
      </div>
    </div>

    <!-- 双模式 -->
    <div class="desk-modes">
      <span class="section-eyebrow">WORKBENCH 2.0</span>
      <span class="section-title">新版工作台，两种模式开一场现场</span>
      <div class="mode-grid">
        <div class="mode-card">
          <span class="mode-icon" v-html="ICON_MONITOR"></span>
          <div class="mode-head">
            <span class="mode-name">嗨喵互动大屏</span>
            <span class="mode-tag online">在线互动</span>
          </div>
          <p class="mode-desc">
            微信上墙、扫码签到、红包游戏、幸运抽奖，来宾扫码即可参与，活动数据实时同步。
          </p>
          <span class="mode-entry">进入互动喵 →</span>
        </div>
        <div class="mode-card live">
          <span class="mode-icon" v-html="ICON_DJ"></span>
          <div class="mode-head">
            <span class="mode-name">现场模式</span>
            <span class="mode-tag local">本地工具</span>
            <span class="mode-new">NEW</span>
          </div>
          <p class="mode-desc">
            歌单、暖场视频、外接大屏、活动遥控器，本地播控一站式准备，现场节奏稳稳握在手里。
          </p>
          <span class="mode-entry">继续准备现场 →</span>
        </div>
      </div>
    </div>

    <!-- 现场模式 -->
    <div class="desk-live">
      <div class="live-inner">
        <div class="live-copy">
          <span class="live-eyebrow">NEW · 现场模式</span>
          <h3 class="live-title">把整场现场<br />装进一个窗口</h3>
          <p class="live-sub">
            全新现场模式，为婚礼、年会、路演现场而生。本地运行不怕断网，从暖场到散场，一个窗口全搞定。
          </p>
          <ul class="live-list">
            <li v-for="(item, i) in livePoints" :key="i">
              <span class="live-dot"></span>
              <div class="live-point">
                <span class="lp-name">{{ item.name }}</span>
                <span class="lp-desc">{{ item.desc }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="live-shot">
          <div class="shot-chrome">
            <i></i>
            <i></i>
            <i></i>
            <span>嗨喵工作台 · 现场模式</span>
          </div>
          <img :src="shotLive" alt="嗨喵悦动,嗨喵互动,嗨喵工作台现场模式" />
        </div>
      </div>
    </div>

    <!-- 现场能力 -->
    <div class="desk-features">
      <span class="section-eyebrow">ON-SITE TOOLS</span>
      <span class="section-title">打开就能用的现场能力</span>
      <div class="feature-grid">
        <div v-for="f in features" :key="f.title" class="feature-card">
          <span class="feature-icon" v-html="f.icon"></span>
          <span class="feature-name">{{ f.title }}</span>
          <span class="feature-desc">{{ f.desc }}</span>
        </div>
      </div>
    </div>

    <!-- 界面预览 -->
    <div class="desk-shots">
      <span class="section-eyebrow">PREVIEW</span>
      <span class="section-title">工作台长什么样</span>
      <div class="shot-grid">
        <div class="shot-card">
          <div class="shot-chrome">
            <i></i>
            <i></i>
            <i></i>
            <span>嗨喵工作台 · 首页</span>
          </div>
          <img :src="shotHome" alt="嗨喵悦动,嗨喵互动,嗨喵工作台界面" />
          <span class="shot-caption">双模式首页，今天的现场从这里开始</span>
        </div>
        <div class="shot-card">
          <div class="shot-chrome">
            <i></i>
            <i></i>
            <i></i>
            <span>嗨喵工作台 · 现场模式</span>
          </div>
          <img :src="shotLive" alt="嗨喵悦动,嗨喵互动,嗨喵工作台现场模式界面" />
          <span class="shot-caption">歌单、外接大屏、遥控器，播控一站搞定</span>
        </div>
      </div>
    </div>

    <!-- 底部下载 -->
    <div class="desk-cta-strip">
      <div class="strip-inner">
        <div class="strip-text">
          <span class="strip-title">现在就下载嗨喵工作台</span>
          <span class="strip-sub">Windows / macOS 官方安装包，注册即免费用</span>
        </div>
        <div class="strip-btn" @click="downloadPrimary">
          <span>{{ primaryLabel }}</span>
          <svg viewBox="0 0 24 24">
            <path
              d="M12 4v12m0 0l-5-5m5 5l5-5M6 20h12"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>

    <div class="desk-footer">
      <span>©2026 嗨喵悦动 · 嗨喵工作台官方下载</span>
      <a href="https://www.hudongmiao.com" target="_blank" rel="noopener">嗨喵首页</a>
      <a href="/statement" target="_blank">法律声明</a>
      <a href="/service" target="_blank">用户协议</a>
    </div>
  </div>
</template>

<script>
import { WINDOWDESK, MACDESK_X64, MACDESK_ARM64 } from '@/assets/constant/default';
import {
  isMacOsUserAgent,
  resolveWorkbenchDownloadInfo,
  resolveWorkbenchMacDownloadInfo,
} from '@/utils/desktopEnv';

const SHOT_HOME = 'https://ustatic.hudongmiao.com/miao/common/desk-shot-home-new_1792493191231b871bb47.webp';
const SHOT_LIVE = 'https://ustatic.hudongmiao.com/miao/common/desk-shot-live-new_1792493191232dab2c619.webp';

const ICON_MONITOR = '<svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="12.5" rx="2" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M9.8 8l4 2.3-4 2.3V8z" fill="currentColor"/><path d="M8.5 20.5h7M12 16.5v4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
const ICON_REMOTE = '<svg viewBox="0 0 24 24"><rect x="7.5" y="2.5" width="9" height="19" rx="2.2" fill="none" stroke="currentColor" stroke-width="1.8"/><rect x="10" y="5" width="4" height="2.6" rx="1.3" fill="currentColor"/><circle cx="10.4" cy="11" r="1.1" fill="currentColor"/><circle cx="13.6" cy="11" r="1.1" fill="currentColor"/><circle cx="10.4" cy="14.6" r="1.1" fill="currentColor"/><circle cx="13.6" cy="14.6" r="1.1" fill="currentColor"/></svg>';
const ICON_BOX = '<svg viewBox="0 0 24 24"><path d="M12 3l8 4.2v9.6L12 21l-8-4.2V7.2L12 3z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M4.2 7.4L12 11.5l7.8-4.1M12 11.5V21" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
const ICON_DJ = '<svg viewBox="0 0 24 24"><rect x="2.5" y="5" width="19" height="14" rx="2.2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="7.5" cy="12" r="2.6" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="16.5" cy="12" r="2.6" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M7.5 9.4V7.2h9v2.2M7.5 14.6v2.2h9v-2.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';

export default {
  name: 'desk-web-site',
  data() {
    return {
      shotHome: SHOT_HOME,
      shotLive: SHOT_LIVE,
      ICON_MONITOR,
      ICON_DJ,
      highlights: [
        '全新现场模式：歌单、遥控、外接大屏本地播控',
        '扫码签到 · 弹幕上墙 · 红包游戏 · 幸运抽奖',
        'Windows / macOS（Intel 及 Apple 芯片）全支持',
      ],
      livePoints: [
        { name: '本地歌单管理', desc: '暖场音乐、节奏歌曲拖拽排序，一键播放' },
        { name: '外接大屏投放', desc: '现场大屏画面实时预览，投放状态一目了然' },
        { name: '活动遥控器', desc: '上墙、抽奖、礼物随手控制，无需切换窗口' },
        { name: '场次项目化', desc: '新建、保存、复用每场活动，急停保护更安心' },
      ],
      features: [
        { title: '嗨喵互动大屏', desc: '在线互动一键开屏，来宾扫码即可参与，婚礼、年会都好用', icon: ICON_MONITOR },
        { title: '现场模式', desc: '歌单、外接大屏、遥控器本地播控，断网也能稳住现场', icon: ICON_DJ },
        { title: '活动遥控器', desc: '礼物、弹幕、抽奖随手控制，现场节奏尽在掌握', icon: ICON_REMOTE },
        { title: '大屏资源', desc: '媒体资源包提前缓存到本机，现场播放更流畅', icon: ICON_BOX },
      ],
      isMac: false,
      winUrl: WINDOWDESK,
      winVersion: '',
      macX64Url: MACDESK_X64,
      macArm64Url: MACDESK_ARM64,
      macVersion: '',
    };
  },
  computed: {
    primaryLabel() {
      return this.isMac ? '下载 Mac 版 · Apple 芯片' : '下载 Windows 版';
    },
    primaryVersion() {
      return this.isMac ? this.macVersion : this.winVersion;
    },
    primaryUrl() {
      return this.isMac ? this.macArm64Url : this.winUrl;
    },
    otherPlatforms() {
      return [
        { key: 'win', name: 'Windows', url: this.winUrl },
        { key: 'mac-x64', name: 'Mac · Intel 芯片', url: this.macX64Url },
        { key: 'mac-arm64', name: 'Mac · Apple 芯片', url: this.macArm64Url },
      ].filter((p) => p.url !== this.primaryUrl);
    },
  },
  methods: {
    downloadPrimary() {
      window.open(this.primaryUrl, '_blank', 'noopener');
    },
    // Mac 的 UA 无法区分芯片，顶栏按钮不让 Mac 用户盲下，滚到下载卡片自行选择
    onNavCta() {
      if (this.isMac) {
        const card = document.querySelector('.download-card');
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      this.downloadPrimary();
    },
  },
  created() {
    const ua = (typeof navigator !== 'undefined' && navigator.userAgent) || '';
    this.isMac = isMacOsUserAgent(ua);
    resolveWorkbenchDownloadInfo().then((info) => {
      this.winUrl = info.url;
      this.winVersion = info.version;
    });
    resolveWorkbenchMacDownloadInfo().then((info) => {
      this.macX64Url = info.x64Url;
      this.macArm64Url = info.arm64Url;
      this.macVersion = info.version;
    });
  },
};
</script>

<style lang="less" scoped>
.desk-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #fff8ef 0%, #fffdf9 520px, #ffffff 100%);
  overflow-x: hidden;

  h1 {
    display: none;
  }
}

.desk-nav {
  height: 96px;
  background: rgba(255, 255, 255, 0.72);
  border-bottom: 1px solid rgba(242, 118, 11, 0.1);

  .dn-inner {
    max-width: 1440px;
    height: 100%;
    margin: 0 auto;
    padding: 0 120px;
    display: flex;
    align-items: center;
  }

  .dn-logo {
    width: 53.33px;
    height: 53.33px;
    border-radius: 12px;
    box-shadow: 0 6px 16px rgba(242, 118, 11, 0.28);
  }

  .dn-title {
    display: flex;
    flex-direction: column;
    margin-left: 13.33px;

    .dn-name {
      font-size: 21.33px;
      font-weight: bold;
      color: #333;
    }

    .dn-slogan {
      color: rgba(0, 0, 0, 0.4);
      font-size: 14px;
      margin-top: 3px;
    }
  }

  .dn-home {
    margin-left: auto;
    color: #333;
    font-size: 18.67px;
    padding: 14px 28px;

    &:hover {
      color: #f2760b;
    }
  }

  .dn-cta {
    display: flex;
    align-items: center;
    background: linear-gradient(111deg, #ff9a3d, #f2640a 100%);
    color: #fff;
    font-size: 18.67px;
    padding: 14px 30px;
    border-radius: 8px;
    margin-left: 26.67px;
    box-shadow: 0 8px 20px rgba(242, 118, 11, 0.35);
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;

    .dn-cta-icon {
      width: 20px;
      height: 20px;
      margin-right: 9px;
    }

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 10px 24px rgba(242, 118, 11, 0.45);
    }
  }
}

.desk-hero {
  padding: 30px 120px 0;
  max-width: 1440px;
  margin: 0 auto;
  box-sizing: border-box;

  .hero-card {
    position: relative;
    border-radius: 24px;
    padding: 56px 90px 64px 100px;
    display: flex;
    align-items: center;
    background:
      radial-gradient(720px 420px at 88% 8%, rgba(255, 176, 89, 0.35), transparent 65%),
      radial-gradient(560px 420px at 4% 96%, rgba(255, 132, 40, 0.18), transparent 60%),
      linear-gradient(115deg, #4a2109 0%, #8c440d 48%, #de7418 100%);
    box-shadow: 0 30px 60px rgba(140, 68, 13, 0.25);
    overflow: visible;
  }

  .hero-left {
    flex: 0 0 44%;
    display: flex;
    flex-direction: column;
    color: #fff;
    position: relative;
    z-index: 2;
  }

  .hero-eyebrow {
    display: inline-block;
    align-self: flex-start;
    font-size: 14.67px;
    letter-spacing: 2px;
    color: rgba(255, 255, 255, 0.85);
    border: 1px solid rgba(255, 255, 255, 0.28);
    border-radius: 999px;
    padding: 6px 18px;
    margin-bottom: 18px;
  }

  .hero-title {
    margin: 0;
    font-size: 56px;
    line-height: 1.24;
    font-weight: bold;

    em {
      font-style: normal;
      background: linear-gradient(92deg, #ffd08a 0%, #ff9a3d 60%, #ff8a1e 100%);
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .hero-sub {
    margin: 18px 0 0;
    max-width: 400px;
    font-size: 18.67px;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.82);
  }

  .hero-list {
    list-style: none;
    margin: 20px 0 0;
    padding: 0;

    li {
      display: flex;
      align-items: center;
      font-size: 16.53px;
      color: rgba(255, 255, 255, 0.92);
      margin-bottom: 10.67px;

      svg {
        width: 20px;
        height: 20px;
        margin-right: 12px;
        flex-shrink: 0;
      }
    }
  }

  .download-card {
    margin-top: 28px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 18.67px;
    padding: 26.67px 29.33px;
    backdrop-filter: blur(6px);
  }

  .dl-primary {
    display: flex;
    align-items: center;
    width: 378.67px;
    height: 64px;
    background: #fff;
    border-radius: 999px;
    padding: 0 26.67px;
    box-sizing: border-box;
    color: #e35a03;
    cursor: pointer;
    box-shadow: 0 12px 28px rgba(38, 16, 2, 0.35);
    transition: transform 0.2s, box-shadow 0.2s;

    .dl-os-icon {
      width: 24px;
      height: 24px;
      fill: currentColor;
      flex-shrink: 0;

      &.apple {
        width: 20px;
        height: 24px;
      }
    }

    .dl-text {
      margin-left: 14.67px;
      font-size: 21.33px;
      font-weight: bold;
    }

    .dl-go {
      width: 22px;
      height: 22px;
      margin-left: auto;
      color: #f2760b;
    }

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 16px 32px rgba(38, 16, 2, 0.42);
    }
  }

  .dl-others {
    display: flex;
    align-items: center;
    margin-top: 18.67px;
    font-size: 14.67px;

    .dl-others-label {
      color: rgba(255, 255, 255, 0.55);
      margin-right: 13.33px;
    }

    a {
      color: rgba(255, 255, 255, 0.92);
      text-decoration: none;
      margin-right: 24px;
      border-bottom: 1px dashed rgba(255, 255, 255, 0.4);
      padding-bottom: 2px;

      &:hover {
        color: #ffd08a;
        border-bottom-color: #ffd08a;
      }
    }
  }

  .dl-meta {
    display: flex;
    align-items: center;
    margin-top: 14.67px;
    font-size: 13.33px;
    color: rgba(255, 255, 255, 0.55);

    .dl-version {
      color: #ffd08a;
      margin-right: 16px;
    }
  }

  .hero-right {
    position: relative;
    flex: 1;
    height: 480px;
    margin-left: 60px;
    z-index: 1;

    .ring {
      position: absolute;
      border: 1px solid rgba(255, 255, 255, 0.14);
      border-radius: 50%;

      &.ring-1 {
        width: 440px;
        height: 440px;
        right: -30px;
        top: 0;
      }

      &.ring-2 {
        width: 600px;
        height: 600px;
        right: -60px;
        top: -60px;
        border-color: rgba(255, 255, 255, 0.08);
      }
    }

    .hero-window {
      position: absolute;
      right: -13.33px;
      top: 48px;
      width: 620px;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 42px 84px rgba(40, 17, 2, 0.5);
      border: 1px solid rgba(255, 255, 255, 0.22);

      img {
        display: block;
        width: 100%;
      }

      .hero-badge {
        position: absolute;
        left: 18.67px;
        bottom: 18.67px;
        background: rgba(38, 17, 2, 0.72);
        border: 1px solid rgba(255, 210, 138, 0.5);
        color: #ffd08a;
        font-size: 13.33px;
        letter-spacing: 1px;
        border-radius: 999px;
        padding: 7px 16px;
        backdrop-filter: blur(4px);
      }
    }

    .hero-appicon {
      position: absolute;
      left: -140px;
      top: -12px;
      width: 138.67px;
      height: 138.67px;
      border-radius: 32px;
      border: 6.67px solid rgba(255, 255, 255, 0.92);
      box-shadow: 0 22px 44px rgba(40, 17, 2, 0.45);
      z-index: 3;
    }
  }
}

.section-eyebrow {
  display: block;
  text-align: center;
  font-size: 13.33px;
  letter-spacing: 4px;
  color: #f2910b;
  font-weight: bold;
}

.section-title {
  display: block;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  color: #333;
  margin-top: 10.67px;
}

.desk-modes {
  max-width: 1440px;
  margin: 0 auto;
  padding: 90.67px 120px 0;
  box-sizing: border-box;

  .mode-grid {
    display: flex;
    gap: 32px;
    margin-top: 44px;
  }

  .mode-card {
    position: relative;
    flex: 1;
    background: #fff;
    border: 1px solid rgba(242, 118, 11, 0.12);
    border-radius: 20px;
    padding: 40px 42px 34px;
    box-shadow: 0 16px 36px rgba(190, 120, 40, 0.1);
    display: flex;
    flex-direction: column;
    transition: transform 0.2s, box-shadow 0.2s;

    &:hover {
      transform: translateY(-4px);
      box-shadow: 0 22px 46px rgba(190, 120, 40, 0.16);
    }

    &.live {
      background:
        radial-gradient(360px 200px at 100% 0%, rgba(255, 176, 89, 0.16), transparent 70%),
        linear-gradient(180deg, #fffaf3, #fff5e8);
    }

    .mode-icon {
      width: 60px;
      height: 60px;
      border-radius: 16px;
      background: linear-gradient(135deg, #ff9a3d, #f2640a);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 10px 22px rgba(242, 118, 11, 0.3);

      svg {
        width: 32px;
        height: 32px;
      }
    }

    .mode-head {
      display: flex;
      align-items: center;
      margin-top: 24px;
    }

    .mode-name {
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }

    .mode-tag {
      margin-left: 13.33px;
      font-size: 12.8px;
      border-radius: 999px;
      padding: 4px 12px;
      letter-spacing: 1px;

      &.online {
        color: #f2760b;
        background: rgba(242, 118, 11, 0.1);
        border: 1px solid rgba(242, 118, 11, 0.24);
      }

      &.local {
        color: #8c440d;
        background: rgba(140, 68, 13, 0.08);
        border: 1px solid rgba(140, 68, 13, 0.22);
      }
    }

    .mode-new {
      margin-left: 10.67px;
      font-size: 12.8px;
      font-weight: bold;
      color: #fff;
      background: linear-gradient(111deg, #ff9a3d, #f2640a);
      border-radius: 6px;
      padding: 3px 9px;
      letter-spacing: 1px;
    }

    .mode-desc {
      margin: 14.67px 0 0;
      font-size: 15.47px;
      line-height: 1.75;
      color: rgba(0, 0, 0, 0.5);
    }

    .mode-entry {
      margin-top: auto;
      padding-top: 26.67px;
      font-size: 15.47px;
      font-weight: bold;
      color: #ef7108;
    }
  }
}

.desk-live {
  max-width: 1440px;
  margin: 0 auto;
  padding: 90.67px 120px 0;
  box-sizing: border-box;

  .live-inner {
    position: relative;
    border-radius: 24px;
    padding: 64px 72px;
    display: flex;
    align-items: center;
    gap: 64px;
    background:
      radial-gradient(640px 380px at 10% 10%, rgba(255, 176, 89, 0.22), transparent 65%),
      radial-gradient(520px 420px at 96% 90%, rgba(255, 132, 40, 0.14), transparent 60%),
      linear-gradient(115deg, #38190a 0%, #6b330c 52%, #a85a14 100%);
    box-shadow: 0 30px 60px rgba(104, 50, 10, 0.28);
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      right: -120px;
      top: -120px;
      width: 420px;
      height: 420px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      border-radius: 50%;
    }
  }

  .live-copy {
    flex: 0 0 34%;
    position: relative;
    z-index: 2;
  }

  .live-eyebrow {
    display: inline-block;
    font-size: 13.33px;
    letter-spacing: 3px;
    font-weight: bold;
    color: #ffd08a;
    border: 1px solid rgba(255, 208, 138, 0.4);
    border-radius: 999px;
    padding: 6px 16px;
  }

  .live-title {
    margin: 20px 0 0;
    font-size: 42.67px;
    line-height: 1.3;
    font-weight: bold;
    color: #fff;
  }

  .live-sub {
    margin: 16px 0 0;
    font-size: 16px;
    line-height: 1.75;
    color: rgba(255, 255, 255, 0.78);
  }

  .live-list {
    list-style: none;
    margin: 26.67px 0 0;
    padding: 0;

    li {
      display: flex;
      align-items: flex-start;
      margin-bottom: 18.67px;

      .live-dot {
        width: 9.6px;
        height: 9.6px;
        border-radius: 50%;
        background: #ff9a3d;
        box-shadow: 0 0 0 4px rgba(255, 154, 61, 0.22);
        margin: 7px 14.67px 0 0;
        flex-shrink: 0;
      }

      .live-point {
        display: flex;
        flex-direction: column;

        .lp-name {
          font-size: 16.53px;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.95);
        }

        .lp-desc {
          font-size: 14px;
          color: rgba(255, 255, 255, 0.62);
          margin-top: 3px;
        }
      }
    }
  }

  .live-shot {
    flex: 1;
    position: relative;
    z-index: 2;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 40px 80px rgba(30, 12, 2, 0.45);
    border: 1px solid rgba(255, 255, 255, 0.18);

    img {
      display: block;
      width: 100%;
    }
  }

  .shot-chrome {
    display: flex;
    align-items: center;
    height: 42.67px;
    background: linear-gradient(180deg, #2b1608, #43230d);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding: 0 18.67px;

    i {
      width: 10.67px;
      height: 10.67px;
      border-radius: 50%;
      margin-right: 8px;
      background: #ff5f57;

      &:nth-child(2) {
        background: #febc2e;
      }

      &:nth-child(3) {
        background: #28c840;
      }
    }

    span {
      margin-left: 12px;
      font-size: 13.33px;
      color: rgba(255, 255, 255, 0.55);
    }
  }
}

.desk-features {
  max-width: 1440px;
  margin: 0 auto;
  padding: 90.67px 120px 0;
  box-sizing: border-box;

  .feature-grid {
    display: flex;
    gap: 24px;
    margin-top: 44px;
  }

  .feature-card {
    flex: 1;
    background: #fff;
    border: 1px solid rgba(242, 118, 11, 0.12);
    border-radius: 16px;
    padding: 30.67px 26.67px;
    box-shadow: 0 12px 28px rgba(190, 120, 40, 0.08);
    display: flex;
    flex-direction: column;

    .feature-icon {
      width: 53.33px;
      height: 53.33px;
      border-radius: 14.67px;
      background: linear-gradient(135deg, #fff1e0, #ffdfc2);
      color: #ef7108;
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 28px;
        height: 28px;
      }
    }

    .feature-name {
      font-size: 18.67px;
      font-weight: bold;
      color: #333;
      margin-top: 20px;
    }

    .feature-desc {
      font-size: 14.67px;
      line-height: 1.7;
      color: rgba(0, 0, 0, 0.45);
      margin-top: 9.33px;
    }
  }
}

.desk-shots {
  max-width: 1440px;
  margin: 0 auto;
  padding: 90.67px 120px 0;
  box-sizing: border-box;

  .shot-grid {
    display: flex;
    gap: 32px;
    margin-top: 44px;
  }

  .shot-card {
    flex: 1;
    background: #fff;
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 20px 44px rgba(190, 120, 40, 0.12);
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .shot-chrome {
      display: flex;
      align-items: center;
      height: 42.67px;
      background: linear-gradient(180deg, #fff7ee, #ffeeda);
      border-bottom: 1px solid rgba(242, 118, 11, 0.12);
      padding: 0 18.67px;

      i {
        width: 10.67px;
        height: 10.67px;
        border-radius: 50%;
        margin-right: 8px;
        background: #ff5f57;

        &:nth-child(2) {
          background: #febc2e;
        }

        &:nth-child(3) {
          background: #28c840;
        }
      }

      span {
        margin-left: 12px;
        font-size: 13.33px;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    img {
      display: block;
      width: 100%;
    }

    .shot-caption {
      text-align: center;
      font-size: 15.47px;
      color: rgba(0, 0, 0, 0.55);
      padding: 18.67px 0;
    }
  }
}

.desk-cta-strip {
  max-width: 1440px;
  margin: 0 auto;
  padding: 90.67px 120px 0;
  box-sizing: border-box;

  .strip-inner {
    border-radius: 24px;
    padding: 44px 64px;
    display: flex;
    align-items: center;
    background:
      radial-gradient(560px 300px at 90% 0%, rgba(255, 255, 255, 0.16), transparent 60%),
      linear-gradient(111deg, #ff9a3d, #f2640a 100%);
    box-shadow: 0 24px 48px rgba(242, 118, 11, 0.3);
  }

  .strip-text {
    display: flex;
    flex-direction: column;
    color: #fff;

    .strip-title {
      font-size: 29.33px;
      font-weight: bold;
    }

    .strip-sub {
      font-size: 16px;
      margin-top: 9.33px;
      color: rgba(255, 255, 255, 0.88);
    }
  }

  .strip-btn {
    margin-left: auto;
    display: flex;
    align-items: center;
    background: #fff;
    color: #e35a03;
    font-size: 18.67px;
    font-weight: bold;
    border-radius: 999px;
    padding: 17.33px 37.33px;
    cursor: pointer;
    box-shadow: 0 12px 26px rgba(80, 34, 4, 0.25);
    transition: transform 0.2s;

    svg {
      width: 20px;
      height: 20px;
      margin-left: 10.67px;
    }

    &:hover {
      transform: translateY(-2px);
    }
  }
}

.desk-footer {
  max-width: 1440px;
  margin: 0 auto;
  padding: 56px 120px 40px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.4);

  a {
    color: rgba(0, 0, 0, 0.4);
    margin-left: 32px;
    text-decoration: none;

    &:hover {
      color: #f2760b;
    }
  }
}
</style>
